import $ from 'jquery';
import 'slick-carousel';

$(".blog-category-slider").each(function () {

  const sliderID = $(this).data("slider");

  const $blogCategorySlider = $(`.${sliderID}`);

  $blogCategorySlider.slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "8%",
        },
      },
    ],
  });

});